import URL from '@/tools/url';
import jquery from 'jquery';
import _forIn from 'lodash/forIn';
import _toFinite from 'lodash/toFinite';

/**
 * @description
 * Обновление состава корзины.
 * Позволяет:
 * - обновить состав корзины
 * - удалить несколько позиций
 * - добавить несколько позиций
 * - изменить кол-во товаров позиции
 * - установить комментарии к позициям
 *
 * @param {Object} items - набор пар {variant_id: quantity, ...}. Если quantity = 0, то позиция удаляется из корзины, в противном случае устанавливается указанное кол-во
 * @param {Object} options - дополнительные поля: comments, coupon
 * @param {Object} options.comments - объект с комментариями вида {variant_id: comment, ...}
 * @param {String} options.coupon - название купона
 *
 * @return {$.ajax} Ajax запрос к корзине
 *
 * @example
 * var items = {
 *   123456: 1,
 *   123457: 3,
 *   123450: 100
 * };
 *
 * var options = {
 *   comments: { 123456: 'Ваш комментарий' },
 *   coupon: 'test'
 * }
 *
 * ajaxAPI.cart.update(items, optins)
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */
export default function(items, options) {
  const result = jquery.Deferred();
  const lang = URL.getKeyValue('lang') || '';
  const fields = {
    lang,
    _method: 'patch',
    variant_ids: {},
    accessoriable_variant_ids: items.accessoriable_variant_ids || {},
    order_line_comments: {}
  };
  const _options = options || {};

  _forIn(items, function(value, variant_id) {
    if (Object.keys(value).length) {
      return;
    }

    fields.variant_ids[variant_id] = _toFinite(value);
  });

  if (_options.comments) {
    _forIn(_options.comments, function(comment, variant_id) {
      var item = window.InsalesCommonCart.order.getItemByID(variant_id);
      var thisComment = (item) ? item.comment : '';
      if (item && thisComment !== comment) {
        fields.order_line_comments[variant_id] = comment;
      } else if (!item) {
        fields.order_line_comments[variant_id] = comment;
      }
    });
  }

  if (_options.warehouse_id) {
    fields.warehouse_id = _options.warehouse_id;
  }

  if (_options.coupon) {
    fields.coupon = _options.coupon;
  }

  return jquery.ajax({
    url: '/front_api/cart.json',
    data: JSON.stringify(fields),
    contentType: 'application/json',
    type: 'PATCH',
    success: function(response) {
      if (response.status == 'ok') {
        result.resolve({ status: 'ok' });
      } else {
        result.reject(response);
      }
    }
  });
}
